import createElement from "./create-element.js";

class Result {
  constructor({ id, name, location, description = "", image }, searchText, highlighter) {
    this.regex = new RegExp(searchText, "gi");
    this.highlighter = highlighter;
    const highlightedName = this.highlightMatchedText(name);
    const highlightedLocation = this.highlightMatchedText(location);
    const highlightedDescription = this.highlightMatchedText(this.truncateDescription(description));
    this.matchedText = this.regex.test(name) ? name : location;
    const imageIsDataURL = image.startsWith("data");
    if (!imageIsDataURL) image = `${image}@small.png`;

    this.element = createElement(`
      <li class="list-group-item result w-100 bg-transparent m-0 border-0 px-3 py-2">
        <a
          href="#!"
          class="
            result-link
            dropdown-item
            position-relative
            border-light
            rounded-2
            overflow-hidden
            w-100
            p-0
            d-flex
            bg-transparent
            text-light
          "
          data-id="${id}"
        >
          <div class="result-image-container overflow-hidden rounded-2 flex-shrink-0">
            <img src="${image}" class="result-image" />
          </div>
          <div class="result-details overflow-hidden px-3 flex-grow-1 flex-shrink-1 d-flex flex-column justify-content-between">
            <div class="result-name">${highlightedName}</div>
              <div class="result-location">${highlightedLocation}</div>
              <div
                class="
                  result-description
                  overflow-hidden
                  w-100
                  text-truncate
                  ${description ? "" : "d-none"}
                "
              >
                ${highlightedDescription}
              </div>
            </div>
          </a>
        </li>
    `);

    this.observers = [];
    this.addClickListener();
  }

  truncateDescription(description) {
    const firstIndex = description.search(this.regex);
    if (firstIndex === -1 || firstIndex === 0) return description;
    let firstPart = description.substring(0, firstIndex);
    if (!firstPart.includes(" ")) return description;
    firstPart = firstPart.substring(firstPart.lastIndexOf(" "));
    return `${firstPart.replace(" ", "...")}${description.substring(firstIndex)}`;
  }

  highlightMatchedText(matchedText) {
    return matchedText.replace(this.regex, (match) => `<${this.highlighter}>${match}</${this.highlighter}>`);
  }

  addClickListener() {
    const link = this.element.querySelector(".result-link");

    link.addEventListener("click", (event) => {
      event.preventDefault();

      for (const observer of this.observers) {
        observer(link.dataset.id, this.matchedText);
      }
    });
  }

  addObserver(observer) {
    this.observers.push(observer);
  }
}

export default Result;